// 计费单

import {
    HttpGetInventoryReserve,
    HttpGetInventoryReserveExport,
    HttpGetProduct,
    HttpGetDistributionOne,
    HttpGetDistributionById
} from '@/service/inventory';
import TableList from "@components/templates/tablelist";
import comExcel from '@components/templates/excelalert';
import mixin from "../mixin";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList, mixin],
    components: {
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            products:[],
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true },
        };
    },
    watch:{
        "$route":function (to,from) {
            this.$set(this.formData,"search[EQ_organizationId]",this.isAdmin() ? '' : global.SYSID)
            this.updateList();
        }
    },
    methods: {
        ajaxRequest: HttpGetInventoryReserve,
        async interceptResponse(params){
            console.log(params);
            if(params.content.length>0){
                let productIds = [];
                params.content.forEach(item => {
                    productIds.push(item.productId);
                  });
                HttpGetProduct({
                    contextId: global.SYSID,
                    productIds:productIds
                  })
                .then(res => {
                    this.products = res.data;
                })
                .catch(err => {
                    this.$VMessage.error(err.message);
                });
            }
            let dataList = []
            let idList = [];
            let idMap = {};
            params.content.forEach(item => {
                if (item.srcLabel == 10) {
                    let disId = item.sourceNo.split('-')[1];
                    idList.push(disId);
                }
            });
            if(idList.length!=0){
                await HttpGetDistributionById({
                    deliverOrderIds: idList
                }).then(res => {
                    console.log('res', res);
                    idMap = res.data;
                }, err => {
                    this.$VMessage.error(err);
                });
            }
            params.content.map(item => {
                let disNo = '';
                if (item.srcLabel == 10) {
                    let disId = item.sourceNo.split('-')[1];
                    disNo = idMap[disId];
                }
                dataList.push({
                    ...item,
                    disNo: disNo
                })
            });
            // await params.content.map(async item => {
            //     // 配货单号
            //     let disId = item.sourceNo.split('-')[1];
            //     let disNo = '';
            //     if (item.srcLabel == 10) {
            //         await HttpGetDistributionOne({
            //             deliverOrderId: disId
            //         }).then(res => {
            //             disNo = res.data.deliverOrderNo
            //         }, err => {
            //         })
            //     }
            //     dataList.push({
            //         ...item,
            //         disNo: disNo
            //     });
            // });
            this.$set(this, 'dataList', dataList);
            
        },
        interceptRequest(params) {
            
            params.state = this.isAdmin() ? '1' : '0';
            params.search.EQ_pairStatus = 0;
            this.formData.state = params.state;
            this.formData.search.EQ_pairStatus = 0;
            return params
            
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpGetInventoryReserveExport,this.formData, 'download').then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    });
                    break;
            }
        },
        isAdmin() {
            return this.$route.name === 'inventorySerReserve';
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList','getSelfmanageorgList', 'getBillcusorgList', 'getCusproductList', 'getSystemWareList','getAdminTransferWarehouse', 'getTransferWarehouse','getBillcusWareList','getManageAccountList','getOrgAccountList']),
        // ...mapGetters('common', ['getInventoryType', 'getInventoryReserveSrcLabel']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    show: this.handleAuth('fbb.inwentoryreserve.export'),
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: "组织" }),
                    key: 'EQ_organizationId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    hidden: !this.isAdmin(),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    key: this.isAdmin() ? 'IN_orgWarehouseCode' : 'IN_orgWarehouseId',
                    show: true,
                    tag: 'Select',
                    options: this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('bi.work.task_account_id', { defaultValue: "渠道" }),
                    key: 'IN_sourceChannel',
                    more: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getManageAccountList : this.getOrgAccountList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'IN_groupCode',
                    show: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getCusproductList : this.getProductList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: "SKU",
                    key: 'RCN_sku',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.headlogistics.associated_number', { defaultValue: "来源单号" }),
                    key: 'CN_sourceNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inbound.inventory_type', { defaultValue: "库存类型" }),
                    key: 'EQ_inventoryType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getInventoryType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.alloment.order_type', { defaultValue: "单据类型" }),
                    key: 'EQ_srcLabel',
                    more: true,
                    tag: 'vSelect',
                    options: this.getInventoryReserveSrcLabel,
                    hideSearchTip: true,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.alloment.onsite_channel', { defaultValue: "ONSITE仓渠道" }),
                    key: 'EQ_srcLabel',
                    more: true,
                    tag: 'vSelect',
                    hideSearchTip: true,
                    options: this.getBillcusWareList.filter(item=>{
						return item.attach.warehouseType==1&&item.attach.active==1
					}),
                    props: {
                        filterable: true,
                    },
                },
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('fbb.warehouse.sequence', { defaultValue: '序号' }),
                    key: 'id',
                    maxWidth: 200,
                },
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'organizationId',
                    width: this.isAdmin() ? 100 : 0,
                    render: (h, { row }) => {
                        let orgName = this.getSelfmanageorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || {}
                        return orgName.label
                    }
                },
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    maxWidth: 200,
                    render: (h, { row }) => {
                        let orgWarehouseCode = row.orgWarehouseCode
                        const { label } = (this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse).find(function (item) {
                            return item.attach.code == orgWarehouseCode
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('global.common.project', { defaultValue: '项目' }),
                    render: (h, { row }) =>
                        this.findRenderLabel(
                            this.isAdmin() ? this.getCusproductList : this.getProductList,
                            row.groupCode
                        )
                },
                {
                    title: this.$t('bi.work.task_account_id', { defaultValue: '渠道' }),
                    key: 'sourceChannel',
                },
                {
                    title: 'SKU',
                    key: 'sku',
                },
                {
                    title: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let inventoryType = row.inventoryType
                        const { label } = this.getInventoryType.find(function (item) {
                            return item.value == inventoryType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.alloment.order_type', { defaultValue: '单据类型' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let srcLabel = row.srcLabel
                        const { label } = this.getInventoryReserveSrcLabel.find(function (item) {
                            return item.value == srcLabel
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.associated_number', { defaultValue: '来源单号' }),
                    key: 'sourceNo',
                    render: (h, { row }) => {
                        // 只处理类型为销售订单的单据
                        if (row.srcLabel != 10) {
                            return <div>{row.sourceNo}</div>
                        }
                        let arr = row.sourceNo.split('-');
                        let orderNo = arr[0],
                            disturbutionNo = arr[1];
                        let orderUrl = `https://${global.envPrefix}erp${global.DOMAIN}/home/b2corder/upadte/query?id=${orderNo}`;
                        let disturbutionUrl = `https://${global.envPrefix}erp${global.DOMAIN}/home/distribution/update/query?id=${disturbutionNo}`;
                        return <div>
                            <a href={orderUrl} target="_blank">{orderNo}</a> | <a href={disturbutionUrl} target="_blank">{row.disNo}</a>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.inventory.keep_number', { defaultValue: '预留数量' }),
                    key: 'quantity',
                    sortable: true
                },
                {
                    title: `${this.$t('fbb.accountmanage.material_size_length', { defaultValue: '长' })}*${this.$t('fbb.accountmanage.material_size_width', { defaultValue: '宽' })}*${this.$t('fbb.accountmanage.material_size_height', { defaultValue: '高' })}(cm)`,
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var Length = product.length;
                            var Width =  product.width;
                            var Height =  product.height;
                            return <div>{Length}*{Width}*{Height}</div>
                          }
                       
                    }
                },
                {
                    title: this.$t('global.common.weight(g)', { defaultValue: '重量(g)' }),
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var weight2 = product.weight
                            return <div>{weight2}</div>
                          }
                        
                        
                    }
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    width: 150,
                    render: (h, { row }) => {
                        return <div>{row.updatedAt || '--'}</div>
                    }
                },
            ];
        },
    },
};




